import Section from '../Section';
import QuickAdd from '../global/QuickAdd';

export default class CollectionsList extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.loadQuickAdd();
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }
}
